/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Shipping_Date_RequiredInputs */

const en_orders_carrier_shipping_date_required = /** @type {(inputs: Orders_Carrier_Shipping_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping date is required (YYYY-MM-DD).`)
};

const es_orders_carrier_shipping_date_required = /** @type {(inputs: Orders_Carrier_Shipping_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fecha de envio es obligatoria (YYYY-MM-DD).`)
};

/**
* | output |
* | --- |
* | "Shipping date is required (YYYY-MM-DD)." |
*
* @param {Orders_Carrier_Shipping_Date_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_shipping_date_required = /** @type {((inputs?: Orders_Carrier_Shipping_Date_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Shipping_Date_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_shipping_date_required(inputs)
	return es_orders_carrier_shipping_date_required(inputs)
});